import { apiSlice } from "../store/app.api";
import { supabase } from "../utils/API";

const reportApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getMessages: build.query<any, any>({
      queryFn: async () => {
        let { data } = await supabase.from("mtrcb_message").select("*").order("created_at", { ascending: false });
        return { data };
      },
      providesTags: ["messages"],
    }),
    deleteMessage: build.mutation<any, any>({
      queryFn: async (id: string) => {
        let { data } = await supabase
          .from("mtrcb_message")
          .delete()
          .eq("id", id);
        return { data };
      },
      invalidatesTags: ["messages"],
    }),

    addMessage: build.mutation<any, any>({
      queryFn: async (message) => {
        console.log("mtrcb_message", message);
        let { data, error } = await supabase.from("mtrcb_message").insert(message);
        return { data };
      },
      invalidatesTags: ["messages"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetMessagesQuery,
  useDeleteMessageMutation,
  useAddMessageMutation,
} = reportApi;
